import type { MaybeRef } from 'vue';

export const limitsKeys = {
  all: ['limits'] as const,
  limits: (teamUuid?: MaybeRef<string | undefined>) => [...limitsKeys.all, teamUuid] as const,
};
